<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <div class="content-container">
          <p class="title">
            <strong>授权及发布小程序</strong>
            <el-link :underline="false" @click="linkTo('/appltCourse')" type="primary"
              >查看教程</el-link
            >
          </p>
          <div class="content">
            <el-steps direction="vertical" :active="status" finish-status="success">
              <el-step
                :title="
                  appltType == 'wx'
                    ? '已注册微信小程序，立即授权发布'
                    : appltType == 'dy'
                    ? '已注册抖音小程序，立即授权发布'
                    : '已注册支付宝小程序，立即授权发布'
                "
              >
                <div slot="description">
                  <p class="remarks" v-show="appltType == 'wx'">
                    使用微信小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，可以从公众号后台免微信认证创建小程序或直接前往“微信公众平台”注册企业主体的小程序帐号。
                  </p>
                  <p
                    class="remarks"
                    v-show="appltType == 'TINYAPP' || appltType == 'IOTAPP'"
                  >
                    使用支付宝小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，可以从支付宝开放平台创建小程序。
                  </p>
                  <p class="remarks" v-show="appltType == 'dy'">
                    使用抖音小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，可以从抖音开放平台创建小程序。
                  </p>
                  <el-link
                    :underline="false"
                    type="primary"
                    href="https://mp.weixin.qq.com/"
                    target="_blank"
                    v-show="appltType == 'wx'"
                    >官方注册小程序</el-link
                  >
                  <el-link
                    :underline="false"
                    type="primary"
                    href="https://openhome.alipay.com/mini/dev/create"
                    target="_blank"
                    v-show="appltType == 'TINYAPP' || appltType == 'IOTAPP'"
                    >官方注册小程序</el-link
                  >
                  <el-link
                    :underline="false"
                    type="primary"
                    href="https://developer.open-douyin.com/login?action=register"
                    target="_blank"
                    v-show="appltType == 'dy'"
                    >官方注册小程序</el-link
                  >
                  <div class="status" v-if="status <= 0">
                    <el-button size="mini" type="primary" @click="openAuthUrl"
                      >立即授权</el-button
                    >
                  </div>
                  <div class="status" v-else>
                    <p class="text"><i class="el-icon-success"></i> 已授权</p>
                    <p class="info-name">{{ applitInfo.principalName }}</p>
                  </div>
                </div>
              </el-step>
              <el-step title="设置小程序支付方式" v-if="false">
                <div slot="description">
                  <p class="remarks">
                    选择微信支付-自有（开通微信支付）或微信支付（如需使用代销能力，请提前完成<el-link
                      :underline="false"
                      type="primary"
                      @click="linkTo('/setting/certification')"
                      >店铺认证</el-link
                    >并且保证店铺主体和小程序主体一致）
                  </p>
                  <div class="status" v-if="status <= 1">
                    <el-button size="mini" type="primary" :disabled="status < 1"
                      >支付设置</el-button
                    >
                  </div>
                  <div class="status" v-else>
                    <p class="text">支付完成</p>
                  </div>
                </div>
              </el-step>
              <el-step title="完成所有准备，提交审核并发布小程序" v-if="status > 0">
                <div slot="description">
                  <p class="remarks" v-show="appltType == 'wx'">
                    提交微信审核（最长14个工作日），审核通过后即可立即发布版本
                  </p>
                  <p
                    class="remarks"
                    v-show="appltType == 'TINYAPP' || appltType == 'IOTAPP'"
                  >
                    提交支付宝审核（最长14个工作日），审核通过后即可立即发布版本
                  </p>
                  <div class="status" v-if="status <= 1">
                    <el-button
                      size="mini"
                      type="primary"
                      :disabled="status < 1"
                      @click="miniAppProduceRelease"
                      >前往发布</el-button
                    >
                  </div>
                </div>
              </el-step>
              <el-step title="未注册小程序，创建小程序完成授权" v-if="status <= 0">
                <div slot="description">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="linkTo('/applt/createMiniProgram')"
                    v-show="appltType == 'wx'"
                    >创建微信小程序</el-link
                  >
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="linkTo('/appltAliRegisterGuide')"
                    v-show="appltType == 'TINYAPP' || appltType == 'IOTAPP'"
                    >创建支付宝小程序</el-link
                  >
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="openDYCreateUrl"
                    v-show="appltType == 'dy'"
                    >创建抖音小程序</el-link
                  >
                  <div class="status" v-if="status <= 0">
                    <el-button size="mini" type="primary" @click="authorize"
                      >立即创建</el-button
                    >
                  </div>
                </div>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowUrlQrcode,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>小程序授权</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowUrlQrcode = false"
          />
        </div>
        <div class="popup-container">
          <qrcode
            :value="authUrl"
            :options="{ size: 300 }"
            class="scan-code-img"
          ></qrcode>
          <p>请扫一扫二维码进行授权</p>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: aliAuthorizePop,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>支付宝小程序创建</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="aliAuthorizePop = false"
          />
        </div>
        <div class="popup-container">
          <img src="../assets/img/appltCourse/appltAliRGuide-1.png" alt="" />
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: wxAuthorizePop,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>微信小程序创建</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="wxAuthorizePop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="wxAuthorizeForm"
            :rules="wxAuthorizeRules"
            ref="wxAuthorizeForm"
            label-width="98px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="企业名称" prop="businessName">
              <el-input
                type="text"
                placeholder="请输入企业名称"
                v-model="wxAuthorizeForm.businessName"
              ></el-input>
            </el-form-item>
            <el-form-item label="统一信用码" prop="businessRegistNumber">
              <el-input
                type="text"
                placeholder="请输入统一信用码"
                v-model="wxAuthorizeForm.businessRegistNumber"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="统一信用码" prop="businessRegistNumber">
              <el-select
                type="text"
                placeholder="请输入统一信用码"
                v-model="wxAuthorizeForm.businessRegistNumber"
              ></el-select>
            </el-form-item> -->
            <el-form-item label="法人名称" prop="legalPersonaWechat">
              <el-input
                type="text"
                placeholder="请输入法人名称"
                v-model="wxAuthorizeForm.legalPersonaWechat"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业代码类型" prop="businessRegistNumberType">
              <el-select
                v-model="wxAuthorizeForm.businessRegistNumberType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in businessRegistNumberTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法人微信号" prop="legalPersonaName">
              <el-input
                type="text"
                placeholder="请输入法人微信号"
                v-model="wxAuthorizeForm.legalPersonaName"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="submitForm('wxAuthorizeForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: dyAuthorizePop,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>抖音小程序创建</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="dyAuthorizePop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="dyAuthorizeForm"
            :rules="dyAuthorizeRules"
            ref="dyAuthorizeForm"
            label-width="98px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="小程序appId" prop="authorizerAppId">
              <el-input
                type="text"
                placeholder="请输入小程序appId"
                v-model="dyAuthorizeForm.authorizerAppId"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序appSercet" prop="authorizerAppSercet">
              <el-input
                type="text"
                placeholder="请输入小程序appSercet"
                v-model="dyAuthorizeForm.authorizerAppSercet"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序商户号" prop="merchantId">
              <el-input
                type="text"
                placeholder="请输入小程序商户号"
                v-model="dyAuthorizeForm.merchantId"
              ></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickName">
              <el-input
                type="text"
                placeholder="请输入昵称"
                v-model="dyAuthorizeForm.nickName"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="submitForm('dyAuthorizeForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  authorizeView,
  authorizeViewAlipay,
  authorizeViewDY,
  miniAppProduceRelease,
  miniAppProduceReleaseAlipay,
  miniAppProduceReleaseDY,
  getMiniAppInfoAlipay,
  createMiniApp,
  createDYMiniApp,
} from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { mapState, mapActions } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
let checkTimer = null;
export default {
  mixins: [commonFuc],
  data() {
    return {
      authUrl: "",
      isShowUrlQrcode: false,
      aliAuthorizePop: false,
      wxAuthorizePop: false,
      wxAuthorizeForm: {
        businessName: "",
        businessRegistNumber: "",
        legalPersonaWechat: "",
        legalPersonaName: "",
        businessRegistNumberType: 1,
      },
      businessRegistNumberTypeList: [
        {
          value: 1,
          label: "统一社会信用代码",
        },
        {
          value: 2,
          label: "组织机构代码",
        },
        {
          value: 3,
          label: "营业执照注册号",
        },
      ],
      wxAuthorizeRules: {
        businessName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        businessRegistNumber: [
          {
            required: true,
            message: "请输入统一信用码",
            trigger: "blur",
          },
        ],
        legalPersonaWechat: [
          {
            required: true,
            message: "请输入法人名称",
            trigger: "blur",
          },
        ],
        legalPersonaName: [
          {
            required: true,
            message: "请输入法人微信号",
            trigger: "blur",
          },
        ],
      },
      dyAuthorizePop: false,
      dyAuthorizeForm: {
        authorizerAppId: "",
        authorizerAppSercet: "",
        merchantId: "",
        nickName: "",
      },
      dyAuthorizeRules: {
        authorizerAppId: [
          {
            required: true,
            message: "请输入小程序appId",
            trigger: "blur",
          },
        ],
        authorizerAppSercet: [
          {
            required: true,
            message: "请输入小程序appSercet",
            trigger: "blur",
          },
        ],
        merchantId: [
          {
            required: true,
            message: "请输入小程序商户号",
            trigger: "blur",
          },
        ],
        nickName: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      applitInfo: (state) => state.applitInfo,
      appltType: (state) => state.appltType,
    }),
  },
  watch: {
    appltType: {
      handler: function (val) {
        this.getPageData();
      },
      deep: true,
    },
    applitInfo: {
      handler: function (val) {
        this.getPageData();
      },
      deep: true,
    },
    isShowUrlQrcode(val) {
      if (val) {
        this.startCheck();
      } else {
        clearInterval(checkTimer);
        checkTimer = null;
      }
    },
  },
  components: {
    qrcode,
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      if ((this.applitInfo && !this.applitInfo.isAuth) || !this.applitInfo) {
        this.authorizeView();
      }
    },
    openAuthUrl() {
      if (this.appltType == "wx") {
        // location.href = `https://www.wei.gg/miniProgram/MiniAppAuth_authorizeView?userId=${localStorage.getItem(
        //   "userId"
        // )}&sessionId=${localStorage.getItem("sessionId")}`;
        location.href = `${this.authUrl}?userId=${localStorage.getItem(
          "userId"
        )}&sessionId=${localStorage.getItem("sessionId")}`;
      } else if (this.appltType == "dy") {
        window.open(this.authUrl);
      } else {
        this.isShowUrlQrcode = true;
        // location.href = this.authUrl;
      }
    },
    openDYCreateUrl() {
      window.open(
        "https://developer.open-douyin.com/docs/resource/zh-CN/mini-app/develop/guide/develop-process/prepare/#_%E5%88%9B%E5%BB%BA%E5%B0%8F%E7%A8%8B%E5%BA%8F"
      );
    },
    authorizeView() {
      if (this.appltType == "wx") {
        authorizeView().then((res) => {
          if (res.code == 1) {
            this.authUrl = res.data.authorizeViewUrl;
          }
        });
      } else if (this.appltType == "dy") {
        authorizeViewDY().then((res) => {
          if (res.code == 1) {
            this.authUrl = res.data.authorizeViewUrl;
          }
        });
      } else {
        authorizeViewAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.authUrl = res.data.appAuthURL;
          }
        });
      }
    },
    miniAppProduceRelease() {
      if (this.appltType == "wx") {
        miniAppProduceRelease().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else if (this.appltType == "dy") {
        miniAppProduceReleaseDY().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        miniAppProduceReleaseAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      }
    },
    checkAppltStatus() {
      getMiniAppInfoAlipay({
        applicationType: this.appltType,
      }).then((res) => {
        if (res.code == 1) {
          if (res.data.isAuth) {
            this.isShowUrlQrcode = false;
            clearInterval(checkTimer);
            checkTimer = null;
            this.$emit("getMiniAppInfo");
          }
        }
      });
    },
    startCheck() {
      clearInterval(checkTimer);
      checkTimer = null;
      checkTimer = setInterval(this.checkAppltStatus, 1e3);
    },
    authorize() {
      if (this.appltType == "TINYAPP" || this.appltType == "IOTAPP") {
        this.aliAuthorizePop = true;
      } else if (this.appltType == "wx") {
        this.wxAuthorizePop = true;
      } else if (this.appltType == "dy") {
        this.dyAuthorizePop = true;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "wxAuthorizeForm") {
            createMiniApp({
              shopId: localStorage.shopId,
              businessName: this.wxAuthorizeForm.businessName,
              businessRegistNumber: this.wxAuthorizeForm.businessRegistNumber,
              legalPersonaWechat: this.wxAuthorizeForm.legalPersonaWechat,
              legalPersonaName: this.wxAuthorizeForm.legalPersonaName,
              businessRegistNumberType: this.wxAuthorizeForm.businessRegistNumberType,
              componentPhone: "15257763961",
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "小程序申请已经成功，请及时关注法人微信上验证信息，及时验证。",
                  type: "success",
                  duration: 2000,
                });
                this.wxAuthorizePop = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          } else if (formName == "dyAuthorizeForm") {
            createDYMiniApp({
              shopId: localStorage.shopId,
              miniAppPlatform: 4,
              authorizerAppId: this.dyAuthorizeForm.authorizerAppId,
              authorizerAppSercet: this.dyAuthorizeForm.authorizerAppSercet,
              merchantId: this.dyAuthorizeForm.merchantId,
              nickName: this.dyAuthorizeForm.nickName,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "小程序申请已经成功，请及时关注法人微信上验证信息，及时验证。",
                  type: "success",
                  duration: 2000,
                });
                this.dyAuthorizePop = true;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: hidden;
  .bd {
    height: 100%;
    .tab-content {
      padding: 20px;
      .content-container {
        width: 1000px;
        .title {
          strong {
            vertical-align: middle;
            margin-right: 10px;
          }
        }
        .content {
          height: 320px;
          margin-top: 30px;
          .remarks {
            max-width: 70%;
            color: #969799;
            font-size: 12px;
            margin-bottom: 8px;
          }
          .status {
            position: absolute;
            right: 0;
            top: 0;
            width: 20%;
            text-align: left;
            .text {
              font-size: 14px;
              color: #000;
              i {
                color: #2da641;
              }
            }
            .info-name {
              color: #969799;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.applt-page {
  .el-step.is-vertical {
    .el-step__main {
      position: relative;
    }
  }
  .popup {
    z-index: 1000;
  }
  .popup-container {
    padding: 20px;
    &.center {
      text-align: center;
    }
    p {
      font-size: 18px;
      text-align: center;
      line-height: 25px;
    }
  }
}
</style>
